module.exports = __webpack_public_path__ + "static/media/018.da3fc89a.jpg";